import * as mqtt from "precompiled-mqtt";
import {
    CHECK_RESPONSE_TIMEOUT_LOCALSERVER_INTERVAL,
    CLUSTER_REQUEST_TOPIC,
    CLUSTER_RESPONSE_TOPIC_PREFIX,
    HMI_REQUEST_TOPIC,
    HMI_RESPONSE_TOPIC_PREFIX,
    MQTTEventsEnum,
} from "constants/constants";
import { ILocalserverSetupMethodsEntity } from "./LocalserverSetupMethodsInterfaces";
import { handleClusterMessage, handleConnect, handleMachineCenterMessage } from "./helpers";

const { connect } = mqtt;

export const LocalserverSetupMethodsEntity: ILocalserverSetupMethodsEntity = {
    getMachineCenterInfo: (machine_center_id, options, timeoutMs = CHECK_RESPONSE_TIMEOUT_LOCALSERVER_INTERVAL) => {
        return new Promise((resolve, reject) => {
            if (!options) {
                reject("No broker settings provided");
            }

            const responseTopic = `${HMI_RESPONSE_TOPIC_PREFIX}${machine_center_id}`;
            const mosquittoUrl = options.host;
            const timestamp = Date.now();
            const isWSS = mosquittoUrl.startsWith("wss");
            const client = connect(mosquittoUrl, {
                username: options.user,
                password: options.password,
                protocol: isWSS ? "wss" : "ws",
                clean: true,
                clientId: `machine_center_${machine_center_id}`,
            });
            let connectionHandled = false;

            client.on(MQTTEventsEnum.ERROR, (err) => {
                connectionHandled = true;
                reject(err);
            });

            client.on(MQTTEventsEnum.CONNECT, () => {
                if (connectionHandled) {
                    return;
                }
                connectionHandled = true;
                handleConnect(client, responseTopic, HMI_REQUEST_TOPIC, reject, {
                    machineCenterId: machine_center_id,
                    timestamp: timestamp,
                });
            });

            const timeoutId = setTimeout(() => {
                client.end();
                reject(new Error("Request timed out"));
            }, timeoutMs);

            client.on(MQTTEventsEnum.MESSAGE, (topic, message) => {
                connectionHandled = true;
                handleMachineCenterMessage(
                    topic,
                    message,
                    client,
                    responseTopic,
                    timestamp,
                    reject,
                    resolve,
                    timeoutId,
                );
            });

            client.on(MQTTEventsEnum.CLOSE, () => {
                clearTimeout(timeoutId);
                if (!connectionHandled) {
                    connectionHandled = true;
                    reject(new Error("MQTT connection failed"));
                }
            });
        });
    },
    getClusterInfo: (clusterId, options, timeoutMs = CHECK_RESPONSE_TIMEOUT_LOCALSERVER_INTERVAL) => {
        return new Promise((resolve, reject) => {
            if (!options) {
                reject("No broker settings provided");
            }

            const responseTopic = `${CLUSTER_RESPONSE_TOPIC_PREFIX}${clusterId}`;
            const mosquittoUrl = options.host;
            const timestamp = Date.now();
            const isWSS = mosquittoUrl.startsWith("wss");
            const client = connect(mosquittoUrl, {
                username: options.user,
                password: options.password,
                protocol: isWSS ? "wss" : "ws",
                clean: true,
                clientId: `cluster_${clusterId}`,
            });
            let connectionHandled = false;

            client.on(MQTTEventsEnum.ERROR, (err) => {
                connectionHandled = true;
                reject(err);
            });

            client.on(MQTTEventsEnum.CONNECT, () => {
                if (connectionHandled) {
                    return;
                }
                connectionHandled = true;
                handleConnect(client, responseTopic, CLUSTER_REQUEST_TOPIC, reject, {
                    clusterId: clusterId,
                    timestamp: timestamp,
                });
            });

            const timeoutId = setTimeout(() => {
                client.end();
                reject(new Error("Request timed out"));
            }, timeoutMs);

            client.on(MQTTEventsEnum.MESSAGE, (topic, message) => {
                connectionHandled = true;
                handleClusterMessage(topic, message, client, responseTopic, timestamp, reject, resolve, timeoutId);
            });

            client.on(MQTTEventsEnum.CLOSE, () => {
                clearTimeout(timeoutId);
                if (!connectionHandled) {
                    connectionHandled = true;
                    reject(new Error("MQTT connection failed"));
                }
            });
        });
    },
};
